export default {
  text: 'Du har afgivet en bestilling for mindre end 15 minutter siden! Bekræft, om du vil fortsætte med denne nye bestilling, eller administrer din eksisterende.',
  buttons: {
    see_existing_order: 'Se eksisterende bestilling',
    proceed_new_order: 'Fortsæt med ny bestilling',
  },
};
